import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from '@angular/core';
import {
  BehaviorInputData,
  FidelityReviewSection,
  FormEventEmit,
} from '../../../fidelity.interface';
import { CorrectionNeededFormComponent } from '../correction-needed-form/correction-needed-form.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-correction-needed-behavior',
  standalone: true,
  imports: [CorrectionNeededFormComponent, CommonModule],
  templateUrl: './correction-needed-behavior.component.html',
  styleUrl: './correction-needed-behavior.component.scss',
})
export class CorrectionNeededBehaviorComponent implements OnChanges {
  @Input() fidelityData: BehaviorInputData | null = null;
  @Output() formValueChange = new EventEmitter<FormEventEmit>();

  behvaiorData: FidelityReviewSection | null = null;
  ngOnChanges(): void {
    if (this.fidelityData) {
      this.behvaiorData = this.fidelityData.fidelityData?.behavior ?? null;
    }
  }
}
